var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRankAwardSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2143 26.4286H6.42857C5.64286 26.4286 4.97024 26.1488 4.41071 25.5893C3.85119 25.0298 3.57143 24.3571 3.57143 23.5714V19.7857L0.821429 17C0.559524 16.7143 0.357143 16.3988 0.214286 16.0536C0.0714286 15.7083 0 15.3571 0 15C0 14.6429 0.0714286 14.2917 0.214286 13.9464C0.357143 13.6012 0.559524 13.2857 0.821429 13L3.57143 10.2143V6.42857C3.57143 5.64286 3.85119 4.97024 4.41071 4.41071C4.97024 3.85119 5.64286 3.57143 6.42857 3.57143H10.2143L13 0.821429C13.2857 0.559524 13.6012 0.357143 13.9464 0.214286C14.2917 0.0714286 14.6429 0 15 0C15.3571 0 15.7083 0.0714286 16.0536 0.214286C16.3988 0.357143 16.7143 0.559524 17 0.821429L19.7857 3.57143H23.5714C24.3571 3.57143 25.0298 3.85119 25.5893 4.41071C26.1488 4.97024 26.4286 5.64286 26.4286 6.42857V10.2143L29.1786 13C29.4405 13.2857 29.6429 13.6012 29.7857 13.9464C29.9286 14.2917 30 14.6429 30 15C30 15.3571 29.9286 15.7083 29.7857 16.0536C29.6429 16.3988 29.4405 16.7143 29.1786 17L26.4286 19.7857V23.5714C26.4286 24.3571 26.1488 25.0298 25.5893 25.5893C25.0298 26.1488 24.3571 26.4286 23.5714 26.4286H19.7857L17 29.1786C16.7143 29.4405 16.3988 29.6429 16.0536 29.7857C15.7083 29.9286 15.3571 30 15 30C14.6429 30 14.2917 29.9286 13.9464 29.7857C13.6012 29.6429 13.2857 29.4405 13 29.1786L10.2143 26.4286Z",
    fill: "url(#paint0_linear_4164_95484)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4164_95484",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7E7E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRankAwardSilver);
export default __webpack_public_path__ + "static/media/icon_rank_award_silver.6ade97fc5867daf1c1aa8fe990ab82a6.svg";
export { ForwardRef as ReactComponent };